import { ProductItem } from "@/types";

const userCreditsSummary = (userProducts: ProductItem[]) => {
  const courseStructureOnlyForProducts = userProducts?.map(
    (product) => product.course_info.course_structure,
  );

  const sum = {
    speaking: 0,
    grammar: 0,
    ielts: 0,
    one_to_one: 0,
  };

  courseStructureOnlyForProducts.forEach((array) => {
    array.forEach((obj) => {
      sum.speaking += obj.speaking || 0;
      sum.grammar += obj.grammar || 0;
      sum.ielts += obj.ielts || 0;
      sum.one_to_one += obj.one_to_one || 0;
    });
  });

  let isOneToOneOnly = false;
  if (sum.speaking + sum.grammar + sum.ielts + sum.one_to_one > 0) {
    isOneToOneOnly = false;
  } else {
    if (sum.one_to_one > 0) {
      isOneToOneOnly = true;
    } else {
      isOneToOneOnly = false;
    }
  }
  const sumMinusOneToOne = sum.speaking + sum.grammar + sum.ielts;

  return { sum, isOneToOneOnly, sumMinusOneToOne };
};

export default userCreditsSummary;
